import { TFunction } from 'i18next';
import classes from './ContactsTab.module.scss';
import { IRestrictedUser } from 'interfaces';

type Props = {
  t: TFunction;
  selectedUser: IRestrictedUser;
};

export default function ContactsInfo({ t, selectedUser }: Props) {
  return (
    <div>
      <div className={classes.item}>
        <div className={classes.itemTitle}>{t('PersonalInfo.firstname')}</div>
        <div className={classes.itemValue}>{selectedUser?.first_name}</div>
      </div>

      <div className={classes.item}>
        <div className={classes.itemTitle}>{t('PersonalInfo.lastname')}</div>
        <div className={classes.itemValue}>{selectedUser?.last_name}</div>
      </div>

      <div className={classes.item}>
        <div className={classes.itemTitle}>{t('PersonalInfo.phone')}</div>
        <div className={classes.itemValue}>{selectedUser?.phone_number}</div>
      </div>

      <div className={classes.item}>
        <div className={classes.itemTitle}>{t('PersonalInfo.email')}</div>
        <div className={classes.itemValue}>{selectedUser?.email}</div>
      </div>
    </div>
  );
}
